export default {
	TaxDeclaration: 'Khai thuế',
	DeclarationSubmit: 'Tờ khai phải nộp',
	DueSoon: 'Sắp đến hạn',
	OutOfDate: 'Quá hạn',
	NumberDeclarationRegister: 'Số tờ khai đã đăng ký',
	StatusDeclaration: 'Tình trạng nộp tờ khai',
	FilterBy: 'Lọc theo',
	FromDate: 'Từ ngày',
	ToDate: 'Đến ngày',
	ReApply: 'Đặt lại',
	Apply: 'Áp dụng',
	TaxPayment: 'Nộp thuế',
	NumberTaxHasPayment: 'Số thuế đã nộp',
	ItemCode: 'Mã mục',
	TaxType: 'Loại thuế',
	TotalMoney: 'Số tiền',
	StatusTaxPayment: 'Tình trạng nộp thuế',
	NumberTaxPayment: 'Số tờ khai đã nộp',
	NumberTaxPaper: 'Số giấy nộp tiền đã nộp',
	SubmitDeclaration: 'Nộp tờ khai',
	Started: 'Bắt đầu sử dụng',
	SendMISA: 'Đã gửi MISA',
	SentToTCT: 'Đã gửi TCT',
	TCTApprove: 'TCT tiếp nhận',
	TCTAccept: 'TCT chấp nhận',
	TCTNotReceive: 'TCT không tiếp nhận',
	TCTReject: 'TCT không chấp nhận',
	SendError: 'Gửi TCT thất bại',
	Draft: 'Bản nháp',
	PaperSubmissionSuccess: 'Nộp thuế thành công',
	PaperSubmissionFail: 'Nộp thuế không thành công',
	Currency: 'Loại tiền',
	TaxOther: 'Các khoản thuế khác',
	Other: 'khác',
	Fiscal: 'Quý',
	Month: 'Tháng',
	Period: 'Kỳ',
	PeriodIncurred: 'Ngày',
	PeriodYear: 'Năm',
	Million: 'triệu',
	RemainingDue: value => `Còn ${value} ngày`,
	OverDue: value => `Quá ${value} ngày`,
	MoneyVND: 'VND',
	MoneyUSD: 'USD',
	SeeChartType: 'Xem biểu đồ theo',
	Time: 'Thời gian',
	TypeTaxPaid: 'Loại thuế đã nộp',
	SeeByPeriod: 'Xem theo kỳ',
	TCTProcessingRefund: 'Đang xử lý hoàn thuế',
	CancelRefund: 'Đã hủy hoàn thuế',
	RequestJustify: 'Yêu cầu GTBS hoàn thuế',
	Justified: 'Đã gửi GTBS hoàn thuế',
	Paused: 'Tạm dừng giải quyết hoàn thuế'
};
